import React from "react";
import App from "./App";
import "./index.scss";
import { createRoot } from "react-dom/client";
import { store, persistor } from "./redux/store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { Toaster } from "sonner";
import { ThemeProvider } from "./components/theme-provider";

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme-light">
          <App />
          <Toaster position="bottom-right" richColors expand={true} toastOptions={{ duration: 5000, closeButton: true }} />
        </ThemeProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
